var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dataTable',{attrs:{"table":_vm.org_requests_table,"type":"org_requests"}}),(_vm.org_requests_table.content.body.length > 10)?_c('v-layout',{class:{'px-3': _vm.$vuetify.breakpoint.xs, 'mt-4 justify-center': _vm.$vuetify.breakpoint.smAndDown, 'mt-5 justify-end': _vm.$vuetify.breakpoint.mdAndUp},attrs:{"align-center":"","wrap":""}},[_c('v-flex',{attrs:{"md5":"","sm7":"","xs12":""}},[_c('div',{staticClass:"text-xs-center"},[_c('v-pagination',{attrs:{"length":_vm.pages,"total-visible":_vm.$vuetify.breakpoint.xs ? 4 : 6,"prev-icon":"arrow_back_ios","next-icon":"arrow_forward_ios"},model:{value:(_vm.pagination),callback:function ($$v) {_vm.pagination=$$v},expression:"pagination"}})],1)]),_c('v-flex',{class:{'mt-4': _vm.$vuetify.breakpoint.smAndDown},attrs:{"md4":"","sm6":""}},[_c('v-select',{staticClass:"input",attrs:{"items":_vm.$vuetify.breakpoint.mdAndUp ?
                  [
                    {
                      text: _vm.$t('Показывать по 10'),
                      value: 'Показывать по 10',
                    },
                    {
                      text: _vm.$t('Показывать по 25'),
                      value: 'Показывать по 25',
                    },
                    {
                      text: _vm.$t('Показывать по 50'),
                      value: 'Показывать по 50',
                    },
                    {
                      text: _vm.$t('Показывать по 100'),
                      value: 'Показывать по 100',
                    },
                  ]
                  :
                  [
                    {
                      text: _vm.$t('Показывать по 10'),
                      value: 'Показывать по 10',
                    },
                    {
                      text: _vm.$t('Показывать по 25'),
                      value: 'Показывать по 25',
                    },
                    {
                      text: _vm.$t('Показывать по 50'),
                      value: 'Показывать по 50',
                    },
                  ],"solo":"","append-icon":"","label":_vm.$t('Показывать по 10')},on:{"change":function($event){return _vm.SHOW_NUMBER({selected:$event, type: 'org'})}},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('v-icon',{attrs:{"aria-hidden":"true","translate":"no"}},[_vm._v("\n                  expand_more\n                ")])]},proxy:true}],null,false,2051057775)})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }